import { Routes } from '@angular/router';
import { MetaGuard } from '@ngx-meta/core';

import { NoticiasComponent } from './noticias.component';
import { NoticiasDetalheComponent } from './noticias-detalhe/noticias-detalhe.component';
import { environment } from '../../../environments/environment';

export const NOTICIAS_ROUTER: Routes = [
  {
    path: 'noticias',
    component: NoticiasComponent,
    canActivate: [MetaGuard],
    data: {
      meta: {
        title: environment.title+' - Noticias',
        description: 'Fique por dentro de tudo o que acontece na Universidade Ceuma',
      },
    },
  },
  {
    path: 'noticias/:slug',
    component: NoticiasDetalheComponent,
  },
];
